import get from "lodash/get";
import kebabCase from "lodash/kebabCase";
import toPath from "lodash/toPath";

import TOKENS from "./tokens.json";

export function getTokenValue(keyPath, defaultValue) {
  return get(TOKENS, toPath(keyPath).map(kebabCase), defaultValue);
}
